
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import IconOeamtcClose from '@/components/icons/icon-oeamtc-close.svg';

@Component({
  name: 'UpsellingBanner',
  components: {
    IconOeamtcClose
  }
})
export default class UpsellingBanner extends Vue {

}
